import classNames from 'classnames'
import React, { FC } from 'react'

import { wixStudioWelcomeAnimationDataHooks as dataHooks } from './WixStudioWelcomeAnimation.dataHooks'
import s from './WixStudioWelcomeAnimation.scss'

type Image = 'none' | 'agency' | 'freelancer' | 'enterprise' | (string & {})

const images: Record<Image, true> = {
  none: true,
  agency: true,
  freelancer: true,
  enterprise: true,
}

export const WixStudioWelcomeAnimation: FC<{ image?: Image }> = ({ image = 'none' }) => (
  <div data-hook={dataHooks.root()} className={classNames(s.outer, images[image] ? s[image] : s.none)}>
    <div className={s.inner}>
      <div className={s.secondary}></div>
      <div className={s.secondary}></div>
      <div className={s.secondary}></div>
      <div className={s.enterpriseLayer}></div>
      <div className={s.enterpriseLayer}></div>
      <div className={s.enterpriseLayer}></div>
      <div className={s.title}></div>
      <div className={s.subtitle}></div>
      <div className={s.main}></div>
    </div>
  </div>
)
